import script from "./OrderConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=1440ac3c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1440ac3c"]])

export default __exports__